import React from 'react';
import { Flex, Box, Text } from 'components/ui';
import {
    colors, mediaQueries, borders, radii, space
} from 'style/config';
import { wrapFunctionalComponent } from 'utils/framework';
import { AI_CHAT_BLACK_IMAGE } from 'ai/utils/imagePaths';
import { isGenAINewUIEnabledWithRCPS } from 'ai/utils/aiBeautyChat';
import {
    IconImage, FeedbackButtonDesktop, FeedbackButtonMobile, CloseButton
} from 'ai/components/SuperChat/SuperChatHeader';
import { trackMenuToggle } from 'ai/analytics';

function SuperChatHeader({ title, handleToggleFlyer, showFlyer, handleClose }) {
    const iconSrc = showFlyer ? '/img/ufe/ai/super-chat/left-chevron.svg' : '/img/ufe/ai/super-chat/ellipsis.svg';
    const isGenAINewUIEnabled = isGenAINewUIEnabledWithRCPS();

    const handleIconClick = () => {
        if (handleToggleFlyer) {
            trackMenuToggle(!showFlyer);
            handleToggleFlyer();
        }
    };

    // Determine which title to show
    const headerTitle = !showFlyer ? title : '';
    const containerStyle = isGenAINewUIEnabled ? styles.genAiContainer : styles.container;
    const titleContainerStyle = isGenAINewUIEnabled ? styles.genAiTitleContainer : styles.titleContainer;

    return (
        <Flex
            css={containerStyle}
            paddingTop={0}
            paddingBottom={0}
            paddingRight={[space[4], space[4], space[4]]}
            paddingLeft={[0, space[4], space[4]]}
        >
            <FeedbackButtonDesktop
                iconSrc={iconSrc}
                onIconClick={handleIconClick}
                showFlyer={showFlyer}
            />

            <Flex css={titleContainerStyle}>
                {isGenAINewUIEnabled && !showFlyer && (
                    <IconImage
                        src={AI_CHAT_BLACK_IMAGE}
                        marginRight={2}
                    />
                )}
                {!(isGenAINewUIEnabled && showFlyer) && (
                    <Text
                        fontWeight='bold'
                        fontSize={isGenAINewUIEnabled ? 'base' : 'md'}
                        lineHeight='tight'
                        color='black'
                    >
                        {headerTitle}
                    </Text>
                )}
            </Flex>

            <Flex css={styles.actionsContainer}>
                <FeedbackButtonMobile
                    iconSrc={iconSrc}
                    onIconClick={handleIconClick}
                    showFlyer={showFlyer}
                />
                <CloseButton
                    display={['flex', 'none', 'none']}
                    onClose={handleClose}
                />
            </Flex>

            <CloseButton
                display={['none', 'flex', 'flex']}
                onClose={handleClose}
            />

            <Box
                position='absolute'
                width='100%'
                height='1px'
                left='0'
                bottom='0'
                backgroundColor={isGenAINewUIEnabled ? 'none' : colors.lightGray}
            />
        </Flex>
    );
}

const baseContainer = {
    alignSelf: 'stretch',
    height: '50px',
    borderTopLeftRadius: radii[3],
    borderTopRightRadius: radii[3],
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative'
};

const baseTitleContainer = {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    [mediaQueries.smMax]: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        flex: 'none'
    }
};

const styles = {
    container: {
        ...baseContainer,
        borderBottom: `${borders[1]} ${colors.lightGray}`,
        backgroundColor: colors.white
    },
    genAiContainer: {
        ...baseContainer,
        borderBottom: 'none',
        background: 'rgba(255, 255, 255, 0.10)',
        backdropFilter: 'blur(50px)',
        WebkitBackdropFilter: 'blur(50px)'
    },
    titleContainer: {
        ...baseTitleContainer,
        position: 'inherit'
    },
    genAiTitleContainer: {
        ...baseTitleContainer,
        position: 'relative'
    },
    actionsContainer: {
        display: 'none',
        alignItems: 'center',
        gap: space[5],
        [mediaQueries.smMax]: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%'
        }
    }
};

export default wrapFunctionalComponent(SuperChatHeader, 'SuperChatHeader');
